import type { Campaign, Collab, ProductDefault } from '@foodfluence/shared';
import {
  campaignOffersProductChoice,
  getCampaignPickLimit,
  getCampaignProducts,
  getOptionalProducts,
  getProductSummaryLabel,
} from '@foodfluence/shared';

/**
 * The products this collab is about: what the creator chose where they have chosen, the campaign's
 * whole offer where they have not.
 */
export const collabProducts = (
  collab: Pick<Collab, 'selectedProducts'> | undefined | null,
  campaign: Parameters<typeof getCampaignProducts>[0]
): ProductDefault[] =>
  collab?.selectedProducts?.length ? collab.selectedProducts : getCampaignProducts(campaign);

/**
 * One short line naming them — `Tote +2 more`. Empty when the campaign carries no product.
 *
 * Every creator-facing label used to render `campaign.productName`, which is only the FIRST
 * product's name; a creator offered three things was told about one.
 */
export const collabProductLabel = (
  collab: Pick<Collab, 'selectedProducts'> | undefined | null,
  campaign: Campaign | undefined | null
): string => {
  // Before a creator has chosen, listing every product asserts a bundle they will not receive:
  // a two-product campaign at a limit of one rendered `Red Tee +1 more` for someone getting one
  // item. Describe the choice instead, and only name specific products once they are settled.
  if (!collab?.selectedProducts?.length && campaignOffersProductChoice(campaign)) {
    const optional = getOptionalProducts(getCampaignProducts(campaign)).length;
    return `Choose ${getCampaignPickLimit(campaign)} of ${optional}`;
  }
  return getProductSummaryLabel(collabProducts(collab, campaign));
};
